import React from "react";

const CWS5ModuleContext = React.createContext();

export const CWS5ModuleProvider = CWS5ModuleContext.Provider;
export const CWS5ModuleConsumer = CWS5ModuleContext.Consumer;
export default CWS5ModuleContext;
